import { render, staticRenderFns } from "./ClaimSummary.vue?vue&type=template&id=a9d35904&"
import script from "./ClaimSummary.vue?vue&type=script&lang=js&"
export * from "./ClaimSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports